import React from "react";
import { TableCell, TableHead, TableRow } from "@mui/material";

export const HistoricalTableHeader: React.FC = () => {
  const headerStyle = {
    fontWeight: 600,
    color: "text.secondary",
    background: "#f2f4f7",
    borderBottom: "1px solid #eaecf0",
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell sx={headerStyle}>Date</TableCell>
        <TableCell sx={headerStyle}>Source</TableCell>
        <TableCell sx={headerStyle}>Meal Plan</TableCell>
        <TableCell sx={headerStyle} align="right">
          TDEE
        </TableCell>
        <TableCell sx={headerStyle} align="right">
          Active Energy
        </TableCell>
        <TableCell sx={headerStyle} align="right">
          Resting Energy
        </TableCell>
        <TableCell sx={headerStyle} align="right">
          Target Intake
        </TableCell>
        <TableCell sx={headerStyle} align="right">
          Logged Intake
        </TableCell>
        <TableCell sx={headerStyle} align="right">
          Energy Balance
        </TableCell>
      </TableRow>
    </TableHead>
  );
};
